import { CircleAlert } from 'lucide-react';
import { resolveApiErrorDisplay } from '@/utils/errors';

interface PcmpEditErrorAlertProps {
  error: unknown;
}

/** The API's answer, as it is (VALIDATION_ERROR included), inside the dialog. */
export function PcmpEditErrorAlert({ error }: PcmpEditErrorAlertProps) {
  if (!error) return null;
  const { title, description } = resolveApiErrorDisplay(error, 'Could not save the changes', {
    keepValidationMessage: true,
  });
  return (
    <div
      role="alert"
      className="flex items-start gap-3 rounded-lg border border-destructive/30 bg-destructive/10 px-4 py-3 text-sm text-destructive"
    >
      <CircleAlert className="mt-0.5 size-4 shrink-0" aria-hidden />
      <div className="flex min-w-0 flex-col gap-0.5">
        <span className="font-medium">{title}</span>
        <span className="whitespace-pre-line break-words">{description}</span>
      </div>
    </div>
  );
}
